import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'px' })
export class PixelsPipe implements PipeTransform {
  transform(value: number | string): string {
    return (typeof value === 'number' || typeof value === 'string') && !isNaN(value as number)
      ? `${value}px`
      : '0px';
  }
}
